import React from 'react';
import PropTypes from 'prop-types';

/**
 * Edit boolean checkbox cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */

export const ReadMultiCell = ({ getColumns }) => {
  class ReadMultiCell extends React.Component {

    handleClick = (e) => {
      e.target.parentElement.firstChild.click();
    }

    render() {
      const { dataItem, field } = this.props;
      const value = dataItem[field] === null ? [] : dataItem[field];
      const splitField = field.split(".")[0];
      const item = getColumns().find(item =>
        item.field === splitField
      )

      const td = (
        <td colSpan={this.props.colSpan}
          className={this.props.className}
          style={this.props.style}
          role="gridcell"
          aria-colindex={(this.props.columnIndex || 0) - (this.props.level || 0) + 1}
          aria-selected={false}
          tabIndex="0"
        >
          {value.map(x => x[item.textField]).join(", ")}
        </td>
      );

      return this.props.render ? this.props.render.call(undefined, td, this.props) : td;
    }
  }

  ReadMultiCell.propTypes = {
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func
  }
  return ReadMultiCell
}